import * as Sentry from "@sentry/browser"
import { config } from "@oysterhr/core"
import { setAspectTypeMap } from "@oysterhr/identity/AccountAspectContext"
import { getCompanyMetadata, getStaffMetaData, getTeamMemberMetaData } from "./roleHelpers"

export const amplitudeIdentify = ({ me, company, currentAspect }) => {
  if (window.gon.amplitudeApiKey === undefined || window.gon.amplitudeApiKey === null) {
    return
  }

  try {
    const { id, name, email, createdAsAccountType, roles } = me
    const { isCompany, isEmployee, isContractor, isStaff } = setAspectTypeMap(currentAspect.type)
    const isTeamMember = isEmployee || isContractor

    const userProperties = {
      eventSource: "client_side",
      name: name,
      email: email,
      oysterAdmin: isStaff,
      createdAsAccountType: createdAsAccountType,
      companyId: company ? company.id : null,
      ...(isCompany
        ? getCompanyMetadata(roles.filter(role => role?.company?.id === company?.id))
        : {}),
      ...(isTeamMember ? getTeamMemberMetaData(currentAspect.type, currentAspect.engagement) : {}),
      ...(isStaff ? getStaffMetaData() : {}),
    }

    amplitude.getInstance().setUserId(id)
    amplitude.getInstance().setUserProperties(userProperties)
  } catch (err) {
    config.isProductionEnvironment
      ? Sentry.captureException(err)
      : console.warn("Amplitude not initialized")
  }
}

export const amplitudeLogEvent = (eventName, eventProperties = {}) => {
  if (window.gon.amplitudeApiKey === undefined || window.gon.amplitudeApiKey === null) {
    return
  }

  try {
    amplitude.getInstance().logEvent(eventName, {
      eventSource: "client_side",
      ...eventProperties,
    })
  } catch (err) {
    config.isProductionEnvironment
      ? Sentry.captureException(err)
      : console.warn("Amplitude not initialized")
  }
}
